import React, { Component } from "react"
import Button from "@material-ui/core/Button"
import FormControlLabel from "@material-ui/core/FormControlLabel"
import { Link } from "react-router-dom"
import Grid from "@material-ui/core/Grid"
import Typography from "@material-ui/core/Typography"
import Container from "@material-ui/core/Container"
import { withStyles } from "@material-ui/core"
import { Cookies } from "react-cookie"
import { Alert, AlertTitle } from "@material-ui/lab"
import { Redirect } from "react-router-dom"
import Paper from "@material-ui/core/Paper"
import Table from "@material-ui/core/Table"
import TableBody from "@material-ui/core/TableBody"
import TableCell from "@material-ui/core/TableCell"
import TableContainer from "@material-ui/core/TableContainer"
import TableHead from "@material-ui/core/TableHead"
import TablePagination from "@material-ui/core/TablePagination"
import TableRow from "@material-ui/core/TableRow"
import Snackbar from "@material-ui/core/Snackbar"
import * as constants from "../constants"
import TableSortLabel from "@material-ui/core/TableSortLabel"

import "react-modern-calendar-datepicker/lib/DatePicker.css"

import Select from "react-select"
import ReactExport from "react-data-export"
import FloatingLabelInput from "./FloatingLabelInput";
import Collapse from "@material-ui/core/Collapse";
import Divider from "@material-ui/core/Divider";
import {Multiselect} from "multiselect-react-dropdown";

const ExcelFile = ReactExport.ExcelFile
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn

const styleselect = {
      multiselectContainer: {
            // To change css for multiselect (Width,height,etc..)
            fontSize: "14px",
            border: "1.25px solid #bababa",
            borderRadius: "4px",
            marginTop: "15px",
      },
      searchBox: {
            // To change search box element look
            fontSize: "14px",
            minheight: "50px",
            textAlign: "right",
            padding: " 10px",
      },
      inputField: {
            // To change input field position or margin
            margin: "5px",
            fontSize: "14px",
      },
      chips: {
            // To change css chips(Selected options)
            //  background: '#00000000',
            border: "2px solid",
            fontSize: "14px",
      },
      optionContainer: {
            // To change css for option container
            textAlign: "right",
      },
      option: {
            // To change css for dropdown options
            fontSize: "14px",
            textAlign: "right",
      },
      groupHeading: {
            // To chanage group heading style
      },
}

const styles = (theme) => ({
      paperrtl: {
            marginTop: theme.spacing(0),
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
      },
      paper: {
            display: "flex",
            flexWrap: "wrap",
            "& > *": {
                  margin: theme.spacing(1),
                  width: theme.spacing(20),
            },
      },
      root: {
            width: "100%",
            margin: "15px",
            padding: "8px",
            direction: "rtl",
      },
      container: {
            maxHeight: 400,
      },
      large: {
            width: theme.spacing(10),
            height: theme.spacing(10),
      },
})

class ChangeUserTherapyList extends Component {
      cookies = new Cookies()
      temp333
      constructor(props) {
            super(props)

            this.state = {
                  redirect: false,
                  errstr: "",
                  errstatus: false,
                  okstatus: false,
                  requestinfos: [],
                  agentInfofilter: [],
                  rowsPerPage: 10,
                  page: 0,
                  organ_user_therapy: {},
                  organ_user_searche_therapy:{},
                  orderBy: "organ_user_therapy_id",
                  order: "desc",
                  snackstr: "",
                  showSnack: false,
                  snackMode: "success",
                  newKindOrganrequest: false,
                  showPaperChart:false,
                  arrCount:0,



                  optionFilterSendrequestKind: "",
                  optionBaseinsurer: [{ value: "1", label: "تامسن اجتماعی" }],
                  optionKind:[{ value: "1", label: "بیمه شده اصلی" }],
                  optionKindship: [{ value: "1", label: "بیمه شده اصلی" }],
                  optionBank: [{ value: "1", label: "بانک" }],
                  optionGender: [{ value: "1", label: "آاقا" }],
                  selectedContract: { value: "0", label: "همه قراردادها" },
                  optionContract: [{ value: "0", label: "همه قراردادها" }],
                  optionOrgan: [{ value: "0", label: "همه سازمان ها" }],
                  selectedOrgan: { value: "0", label: "همه سازمان ها" },



            }
      }

      handleClickcloseTasckBar = (event) => {
            this.setState({ showSnack: false })
      }

      handleSelectRows = (row2) => {
            console.log(row2.kindorgansendrequest_agent_id)
            this.setState(
                  {
                        organ_user_therapy: row2,
                        newKindOrganrequest: true,

                     },
                  () => {
                      //  this.getoptionContractID()
                  }
            )
      }

      newKindOrganrequestFunc = (event) => {
            console.log(this.state.organ_user_therapy)
            this.setState({
                  organ_user_therapy: {},
                 // newKindOrganrequest: false,
                 // selectedOrgan: { value: "0", label: "همه سازمان ها" },
              //    selectedContract: { value: "0", label: "همه قرادادها" },
            })
      }
      componentDidMount() {
            if (this.cookies.get("employee_token_str")) {
                  this.props.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              if (arr.result === "ok") {
                                    self.getoptionOrgan()
                                    self.getoptionBaseinsurer()
                                    self.getoptionKind()
                                    self.getoptionKindship()
                                    self.getoptionBank()
                                    self.getoptionGender()
                                    self.getOrganTherapyList()

                              } else if (arr.result === "error") {
                                    self.setState({ redirect: true })
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "checkemployeelogin")

                  xhttp.open("POST", `${constants.BASE_URL}/employeelogin`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ redirect: true })
            }
      }

      getOrganTherapyList=()=> {
            const {
                  organ_user_searche_therapy,rowsPerPage,page
            } = this.state
            console.log(organ_user_searche_therapy)
            this.props.props.props.dispatch({
                  type: "WAITSHOW",
            })
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        console.log(arr)
                        if (arr.result === "ok") {
                              self.setState({ requestinfos: arr.data, agentInfofilter: arr.data, arrCount: arr.cnt }, () => {})
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        } else if (arr.result === "eror") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                        self.props.props.props.dispatch({
                              type: "WITEHIDE",
                        })
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_user_therapy")
            if(this.state.selectedContract.value!=="0") {
                  fd.append("therapycontract_id", this.state.selectedContract.value)
            }
            if(this.state.selectedOrgan.value!=="0") {
                  fd.append("organ_id", this.state.selectedOrgan.value)
            }
            if(organ_user_searche_therapy.organ_user_therapy_gender_id) {
                  fd.append("organ_user_therapy_gender_id", organ_user_searche_therapy.organ_user_therapy_gender_id)
            }
            if(organ_user_searche_therapy.organ_user_therapy_national_code) {
                  fd.append("organ_user_therapy_national_code", organ_user_searche_therapy.organ_user_therapy_national_code)
            }
            if(organ_user_searche_therapy.organ_user_therapy_name) {
                  fd.append("organ_user_therapy_name", organ_user_searche_therapy.organ_user_therapy_name)
            }
            if(organ_user_searche_therapy.organ_user_therapy_family) {
                  fd.append("organ_user_therapy_family", organ_user_searche_therapy.organ_user_therapy_family)
            }
            if(organ_user_searche_therapy.user_family) {
                  fd.append("user_family", organ_user_searche_therapy.user_family)
            }
            if(organ_user_searche_therapy.user_mobile) {
                  fd.append("user_mobile", organ_user_searche_therapy.user_mobile)
            }
            if(organ_user_searche_therapy.user_name) {
                  fd.append("user_name", organ_user_searche_therapy.user_name)
            }
            if(organ_user_searche_therapy.organ_user_therapy_kinship_id) {
                  fd.append("organ_user_therapy_kinship_id", organ_user_searche_therapy.organ_user_therapy_kinship_id)
            }
            if(organ_user_searche_therapy.organ_user_therapy_personal_code) {
                  fd.append("organ_user_therapy_personal_code", organ_user_searche_therapy.organ_user_therapy_personal_code)
            }
            if(organ_user_searche_therapy.organ_user_therapy_bank_id) {
                  fd.append("organ_user_therapy_bank_id", organ_user_searche_therapy.organ_user_therapy_bank_id)
            }
            if(organ_user_searche_therapy.organ_user_therapy_kind_id) {
                  fd.append("organ_user_therapy_kind_id", organ_user_searche_therapy.organ_user_therapy_kind_id)
            }
            if(organ_user_searche_therapy.organ_user_therapy_bimeno) {
                  fd.append("organ_user_therapy_bimeno", organ_user_searche_therapy.organ_user_therapy_bimeno)
            }
            if(organ_user_searche_therapy.organ_user_therapy_idcardno) {
                  fd.append("organ_user_therapy_idcardno", organ_user_searche_therapy.organ_user_therapy_idcardno)
            }
            if(organ_user_searche_therapy.organ_user_therapy_cardno) {
                  fd.append("organ_user_therapy_cardno", organ_user_searche_therapy.organ_user_therapy_cardno)
            }
            if(organ_user_searche_therapy.organ_user_therapy_accno) {
                  fd.append("organ_user_therapy_accno", organ_user_searche_therapy.organ_user_therapy_accno)
            }
            if(organ_user_searche_therapy.organ_user_therapy_shebano) {
                  fd.append("organ_user_therapy_shebano", organ_user_searche_therapy.organ_user_therapy_shebano)
            }
            if(organ_user_searche_therapy.organ_user_therapy_basebime_id) {
                  fd.append("organ_user_therapy_basebime_id", organ_user_searche_therapy.organ_user_therapy_basebime_id)
            }
            if(organ_user_searche_therapy.organ_user_therapy_main_national_code) {
                  fd.append("organ_user_therapy_main_national_code", organ_user_searche_therapy.organ_user_therapy_main_national_code)
            }

            fd.append("offset", rowsPerPage)
            fd.append("limit", page * rowsPerPage)

            xhttp.open("POST", `${constants.BASE_URL}/organ`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }





      getoptionOrgan = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Organ = [{ value: "0", label: "همه سازمانها" }]
                              for (var k = 0; k < arr.data.length; k++) {
                                    Organ.push({ value: arr.data[k].organ_id, label: arr.data[k].organ_name })
                              }
                              self.setState({ optionOrgan: Organ }, () => {
                                    //   self.getoptionCityID();
                              })
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_organ")
            xhttp.open("POST", `${constants.BASE_URL}/organ`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      getoptionKind = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Organ = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    Organ.push({ value: arr.data[k].user_therapy_kind_id, label: arr.data[k].user_therapy_kind_name })
                              }
                              self.setState({ optionKind: Organ }, () => {
                              })
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_user_therapy_kind")
            xhttp.open("POST", `${constants.BASE_URL}/organ`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }
      getoptionKindship = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Organ = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    Organ.push({ value: arr.data[k].user_therapy_kindship_id, label: arr.data[k].user_therapy_kindship_name })
                              }
                              self.setState({ optionKindship: Organ }, () => {
                              })
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_user_therapy_kindship")
            xhttp.open("POST", `${constants.BASE_URL}/organ`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }
      getoptionBaseinsurer = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Organ = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    Organ.push({ value: arr.data[k].user_therapy_baseinsurer_id, label: arr.data[k].user_therapy_baseinsurer_name })
                              }
                              self.setState({ optionBaseinsurer: Organ }, () => {
                              })
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_user_therapy_baseinsurer")
            xhttp.open("POST", `${constants.BASE_URL}/organ`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }
      getoptionBank = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Organ = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    Organ.push({ value: arr.data[k].user_therapy_bank_id, label: arr.data[k].user_therapy_bank_name })
                              }
                              self.setState({ optionBank: Organ }, () => {
                              })
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_user_therapy_bank")
            xhttp.open("POST", `${constants.BASE_URL}/organ`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }
      getoptionGender = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Organ = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    Organ.push({ value: arr.data[k].user_gender_id, label: arr.data[k].user_gender_name })
                              }
                              self.setState({ optionGender: Organ }, () => {
                              })
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_user_gender")
            xhttp.open("POST", `${constants.BASE_URL}/organ`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      getoptionContractID = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var State = [{ value: "0", label: "همه قرارداد ها" }]
                              for (var k = 0; k < arr.data.length; k++) {
                                    State.push({ value: arr.data[k].organ_therapycontract_id, label: arr.data[k].organ_therapycontract_num })
                              }
                              self.setState({ optionContract: State })
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_therapycontract_byorgan")
            fd.append("organ_therapycontract_organ_id", this.state.selectedOrgan.value)
            xhttp.open("POST", `${constants.BASE_URL}/organ`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      saveNewKindOrganrequest = () => {
            const {
                  selectedCompany,
                  selectedFieldinsurance,
                  selectedState,
                  selectedOrgan,
                  selectedCity,
                  selectedContract,
                  selectedAgent,
            } = this.state

            if (
                  selectedFieldinsurance.value == null ||
                  selectedState.value == null ||
                  selectedOrgan.value == null ||
                  selectedCity.value == null ||
                  selectedContract.value == null ||
                  selectedAgent.value == null
            ) {
                  this.setState({ snackstr: "لطفا پارامتر های فرم را کامل نمایید", showSnack: true, snackMode: "error" })
            } else {
                  this.props.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              console.log(arr)
                              if (arr.result === "ok") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                                    //self.setState({ redirect: true })
                                    self.getOrganTherapyList()
                                    self.newKindOrganrequestFunc()
                              } else if (arr.result === "error") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "add_kindorgansendrequest")

                  fd.append("kindorgansendrequest_organ_id", selectedOrgan.value)
                  fd.append("kindorgansendrequest_contract_id", selectedContract.value)

                  xhttp.open("POST", `${constants.BASE_URL}/kindorgansendrequest`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            }
      }

      ChangeUserTherapyUserList = () => {
            const {organ_user_therapy} = this.state
            console.log(organ_user_therapy)
            this.props.props.props.dispatch({
                  type: "WAITSHOW",
            })

            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        console.log(this.responseText)
                        if (arr.result === "ok") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                              //self.setState({ redirect: true })
                              self.getOrganTherapyList()
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                        self.props.props.props.dispatch({
                              type: "WITEHIDE",
                        })
                  }
            }
            var fd = new FormData()
            fd.append("command", "modify_user_therapy")
            fd.append("organ_user_therapy_id", organ_user_therapy.organ_user_therapy_id)


            if (organ_user_therapy.organ_user_therapy_gender_id) {
                  fd.append("organ_user_therapy_gender_id", organ_user_therapy.organ_user_therapy_gender_id)
            }
            if (organ_user_therapy.organ_user_therapy_year) {
                  fd.append("organ_user_therapy_year", organ_user_therapy.organ_user_therapy_year)
            }
            if (organ_user_therapy.organ_user_therapy_month) {
                  fd.append("organ_user_therapy_month", organ_user_therapy.organ_user_therapy_month)
            }
            if (organ_user_therapy.organ_user_therapy_day) {
                  fd.append("organ_user_therapy_day", organ_user_therapy.organ_user_therapy_day)
            }
            if (organ_user_therapy.organ_user_therapy_fathername) {
                  fd.append("organ_user_therapy_fathername", organ_user_therapy.organ_user_therapy_fathername)
            }
            if (organ_user_therapy.organ_user_therapy_national_code) {
                  fd.append("organ_user_therapy_national_code", organ_user_therapy.organ_user_therapy_national_code)
            }
            if (organ_user_therapy.organ_user_therapy_name) {
                  fd.append("organ_user_therapy_name", organ_user_therapy.organ_user_therapy_name)
            }
            if (organ_user_therapy.organ_user_therapy_family) {
                  fd.append("organ_user_therapy_family", organ_user_therapy.organ_user_therapy_family)
            }
            if (organ_user_therapy.user_family) {
                  fd.append("user_family", organ_user_therapy.user_family)
            }
            if (organ_user_therapy.user_mobile) {
                  fd.append("organ_user_therapy_mobile", organ_user_therapy.user_mobile)
            }
            if (organ_user_therapy.user_name) {
                  fd.append("user_name", organ_user_therapy.user_name)
            }
            if (organ_user_therapy.organ_user_therapy_kinship_id) {
                  fd.append("organ_user_therapy_kinship_id", organ_user_therapy.organ_user_therapy_kinship_id)
            }
            if (organ_user_therapy.organ_user_therapy_personal_code) {
                  fd.append("organ_user_therapy_personal_code", organ_user_therapy.organ_user_therapy_personal_code)
            }
            if (organ_user_therapy.organ_user_therapy_bank_id) {
                  fd.append("organ_user_therapy_bank_id", organ_user_therapy.organ_user_therapy_bank_id)
            }
            if (organ_user_therapy.organ_user_therapy_kind_id) {
                  fd.append("organ_user_therapy_kind_id", organ_user_therapy.organ_user_therapy_kind_id)
            }
            if (organ_user_therapy.organ_user_therapy_bimeno) {
                  fd.append("organ_user_therapy_bimeno", organ_user_therapy.organ_user_therapy_bimeno)
            }
            if (organ_user_therapy.organ_user_therapy_idcardno) {
                  fd.append("organ_user_therapy_idcardno", organ_user_therapy.organ_user_therapy_idcardno)
            }
            if (organ_user_therapy.organ_user_therapy_cardno) {
                  fd.append("organ_user_therapy_cardno", organ_user_therapy.organ_user_therapy_cardno)
            }
            if (organ_user_therapy.organ_user_therapy_accno) {
                  fd.append("organ_user_therapy_accno", organ_user_therapy.organ_user_therapy_accno)
            }
            if (organ_user_therapy.organ_user_therapy_shebano) {
                  fd.append("organ_user_therapy_shebano", organ_user_therapy.organ_user_therapy_shebano)
            }
            if (organ_user_therapy.organ_user_therapy_basebime_id) {
                  fd.append("organ_user_therapy_basebime_id", organ_user_therapy.organ_user_therapy_basebime_id)
            }
            if (organ_user_therapy.organ_user_therapy_main_national_code) {
                  fd.append("organ_user_therapy_main_national_code", organ_user_therapy.organ_user_therapy_main_national_code)
            }

            xhttp.open("POST", `${constants.BASE_URL}organ`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      deletKindOrganrequest = () => {
            const { organ_user_therapy } = this.state

            this.props.props.props.dispatch({
                  type: "WAITSHOW",
            })

            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                              //self.setState({ redirect: true })
                              self.getOrganTherapyList()
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                        self.props.props.props.dispatch({
                              type: "WITEHIDE",
                        })
                  }
            }
            var fd = new FormData()
            fd.append("command", "delete_user_therapy")
            fd.append("organ_user_therapy_id", organ_user_therapy.organ_user_therapy_id)

            xhttp.open("POST", `${constants.BASE_URL}/organ`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      createSortHandler = (field) => {
            if (this.state.orderBy === field) {
                  if (this.state.order === "asc") {
                        this.setState({ order: "desc" })
                  } else {
                        this.setState({ order: "asc" })
                  }
            } else {
                  this.setState({ orderBy: field, order: "asc" })
            }
            var arraytemp = [],
                  i,
                  j,
                  temp,
                  a,
                  b
            arraytemp = this.state.agentInfofilter
            for (i = 0; i < arraytemp.length; i++) {
                  for (j = 0; j < arraytemp.length - 1; j++) {
                        a = arraytemp[j]
                        b = arraytemp[j + 1]
                        if (a[field] < b[field] && this.state.order === "asc") {
                              temp = arraytemp[j]
                              arraytemp[j] = arraytemp[j + 1]
                              arraytemp[j + 1] = temp
                        } else if (a[field] > b[field] && this.state.order === "desc") {
                              temp = arraytemp[j]
                              arraytemp[j] = arraytemp[j + 1]
                              arraytemp[j + 1] = temp
                        }
                  }
            }
      }

      handleChangeRowsPerPage = (event) => {
            this.setState({ rowsPerPage: parseInt(event.target.value), page: 0 },()=>{
                  this.getOrganTherapyList()
            })
      }

      handleChangePage = (event, number) => {
            this.setState({ page: parseInt(number, 0) },()=>{
                  this.getOrganTherapyList()
            })
      }


      handleOrgan = (selectedOrgan) => {
            this.setState({ selectedOrgan: selectedOrgan, selectedContract:  { value: "0", label: "همه قراردادها" } }, () => {
                  this.getoptionContractID()
                  this.getOrganTherapyList()
            })
      }

      handleContract = (selectedContract) => {
            this.setState({ selectedContract: selectedContract }, () => {
                  this.getOrganTherapyList()
            })
      }












      onSelectOptionContract = (selectedList, selectedItem) => {
            this.setState(
                  {
                        selectedFilterContract: selectedList,
                  },
                  () => {}
            )
      }

      onRemoveOptionContract = (selectedList, removedItem) => {
            this.setState(
                  {
                        selectedFilterContract: selectedList,
                  },
                  () => {}
            )
      }

      onSelectOptionOrgan = (selectedList, selectedItem) => {
            this.setState(
                  {
                        selectedFilterOrgan: selectedList,
                  },
                  () => {
                        this.getOptionFilterContract()
                  }
            )
      }








      render() {
            const { classes } = this.props
            const {
                  optionContract,
                  selectedContract,
                  optionOrgan,
                  optionGender,
                  optionKind,
                  optionKindship,
                  optionBaseinsurer,
                  optionBank,
                  selectedOrgan,
                  snackMode,
                  snackstr,
                  showSnack,
                  organ_user_therapy,
                  organ_user_searche_therapy,
                  newKindOrganrequest,
                  order,
                  orderBy,
                  okstatus,
                  errstr,
                  redirect,
                  agentInfofilter,
                  rowsPerPage,
                  page,
                  showPaperChart,
                  arrCount,
            } = this.state
            if (redirect) {
                  return <Redirect to="/" />
            } else {
                  return (
                        <div className={classes.paperrtl} dir="ltr">
                              <Snackbar
                                    anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                                    onClose={this.handleClickcloseTasckBar}
                                    open={showSnack}
                                    autoHideDuration={10000}
                              >
                                    <Alert severity={snackMode}>{snackstr}</Alert>
                              </Snackbar>
                              <Grid container spacing={3}>
                                    <Grid item xs={12}>
                                          <Container component="main" maxWidth="lg">
                                                <Paper elevation={4} className={classes.root}>
                                                      <Grid container spacing={3}>


                                                            <Grid item xs={6}>
                                                                  <div>
                                                                        <label className="on">سازمان</label>
                                                                        <Select
                                                                              isSearchable={true}
                                                                              className="adapter-txtsize"
                                                                              placeholder={"سازمان"}
                                                                              value={selectedOrgan}
                                                                              onChange={this.handleOrgan}
                                                                              options={optionOrgan}
                                                                        />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <div>
                                                                        <label className="on">قرارداد</label>
                                                                        <Select
                                                                              isSearchable={true}
                                                                              className="adapter-txtsize"
                                                                              placeholder={"قرارداد"}
                                                                              value={selectedContract}
                                                                              onChange={this.handleContract}
                                                                              options={optionContract}
                                                                        />
                                                                  </div>
                                                            </Grid>

                                                      </Grid>
                                                </Paper>
                                          </Container>
                                    </Grid>
                                    <Grid item xs={12}>
                                          <Container component="main" maxWidth="lg">
                                                <Paper elevation={4} className={classes.root}>
                                                      {showPaperChart ? (
                                                          <Button variant="outlined" color="primary" onClick={ (event) => {
                                                                this.setState({ showPaperChart: false })
                                                          }}>
                                                                {"مخفی کردن"}
                                                          </Button>
                                                      ) : (
                                                          <Button variant="outlined" color="primary" onClick={ (event) => {
                                                                this.setState({ showPaperChart: true })
                                                          }}>
                                                                {"جستجو"}
                                                          </Button>
                                                      )}

                                                      <Collapse in={showPaperChart}>
                                                            <Grid container spacing={3}>
                                                                  <Grid item xs={12}>
                                                                        <Divider />
                                                                  </Grid>

                                                                  <Grid item xs={4}>
                                                                        <FloatingLabelInput
                                                                            placeholder="نام نفر اصلی"
                                                                            handleInputt={(e) => {
                                                                                  this.setState(
                                                                                      {
                                                                                            organ_user_searche_therapy: {...organ_user_searche_therapy,user_name:e.target.value},
                                                                                      })
                                                                            }
                                                                            }
                                                                            value={organ_user_searche_therapy.user_name}
                                                                        />
                                                                  </Grid>
                                                                  <Grid item xs={4}>
                                                                        <FloatingLabelInput
                                                                            placeholder="نام خانوادگی اصلی"
                                                                            handleInputt={(e) => {
                                                                                  this.setState(
                                                                                      {
                                                                                            organ_user_searche_therapy: {...organ_user_searche_therapy,user_family:e.target.value},
                                                                                      })
                                                                            }
                                                                            }
                                                                            value={organ_user_searche_therapy.user_family}
                                                                        />
                                                                  </Grid>
                                                                  <Grid item xs={4}>
                                                                        <FloatingLabelInput
                                                                            placeholder=" همزاه اصلی"
                                                                            handleInputt={(e) => {
                                                                                  this.setState(
                                                                                      {
                                                                                            organ_user_searche_therapy: {...organ_user_searche_therapy,user_mobile:e.target.value},
                                                                                      })
                                                                            }
                                                                            }
                                                                            value={organ_user_searche_therapy.user_mobile}
                                                                        />

                                                                  </Grid>
                                                                  <Grid item xs={2}>
                                                                        <div>
                                                                              <label className="on">جنسیت</label>
                                                                              <Select
                                                                                  isSearchable={true}
                                                                                  className="adapter-txtsize"
                                                                                  placeholder={"شهر"}
                                                                                  value={optionGender.find((x) => parseInt(x.value) ===  parseInt(organ_user_searche_therapy.organ_user_therapy_gender_id))}
                                                                                  onChange={(e) => {  this.setState(
                                                                                      {
                                                                                            organ_user_searche_therapy: {...organ_user_searche_therapy,organ_user_therapy_gender_id:e.value},
                                                                                      })
                                                                                  } }

                                                                                  options={optionGender}
                                                                              />
                                                                        </div>                                                            </Grid>


                                                                  <Grid item xs={5}>
                                                                        <FloatingLabelInput
                                                                            placeholder="نام"
                                                                            handleInputt={(e) => {
                                                                                  this.setState(
                                                                                      {
                                                                                            organ_user_searche_therapy: {...organ_user_searche_therapy,organ_user_therapy_name:e.target.value},
                                                                                      })
                                                                            }
                                                                            }
                                                                            value={organ_user_searche_therapy.organ_user_therapy_name}
                                                                        />
                                                                  </Grid>
                                                                  <Grid item xs={5}>
                                                                        <FloatingLabelInput
                                                                            placeholder="  نام خانوادگی"
                                                                            handleInputt={(e) => {
                                                                                  this.setState(
                                                                                      {
                                                                                            organ_user_searche_therapy: {...organ_user_searche_therapy,organ_user_therapy_family:e.target.value},
                                                                                      })
                                                                            }
                                                                            }
                                                                            value={organ_user_searche_therapy.organ_user_therapy_family}
                                                                        />
                                                                  </Grid>
                                                                  <Grid item xs={3}>
                                                                        <FloatingLabelInput
                                                                            placeholder="نام پدر"
                                                                            handleInputt={(e) => {
                                                                                  this.setState(
                                                                                      {
                                                                                            organ_user_searche_therapy: {...organ_user_searche_therapy,organ_user_therapy_fathername:e.target.value},
                                                                                      })
                                                                            }
                                                                            }
                                                                            value={organ_user_searche_therapy.organ_user_therapy_fathername}
                                                                        />
                                                                  </Grid>
                                                                  <Grid item xs={3}>
                                                                        <FloatingLabelInput
                                                                            placeholder=" کد پرسنلی سرپرست"
                                                                            handleInputt={(e) => {
                                                                                  this.setState(
                                                                                      {
                                                                                            organ_user_searche_therapy: {...organ_user_searche_therapy,organ_user_therapy_personal_code:e.target.value},
                                                                                      })
                                                                            }
                                                                            }
                                                                            value={organ_user_searche_therapy.organ_user_therapy_personal_code}
                                                                        />
                                                                  </Grid>
                                                                  <Grid item xs={3}>
                                                                        <FloatingLabelInput
                                                                            placeholder=" کد ملی"
                                                                            handleInputt={(e) => {
                                                                                  this.setState(
                                                                                      {
                                                                                            organ_user_searche_therapy: {...organ_user_searche_therapy,organ_user_therapy_national_code:e.target.value},
                                                                                      })
                                                                            }
                                                                            }
                                                                            value={organ_user_searche_therapy.organ_user_therapy_national_code}
                                                                        />
                                                                  </Grid>

                                                                  <Grid item xs={3}>
                                                                        <FloatingLabelInput
                                                                            placeholder="شماره شناسنامه"
                                                                            handleInputt={(e) => {
                                                                                  this.setState(
                                                                                      {
                                                                                            organ_user_searche_therapy: {...organ_user_searche_therapy,organ_user_therapy_idcardno:e.target.value},
                                                                                      })
                                                                            }
                                                                            }
                                                                            value={organ_user_searche_therapy.organ_user_therapy_idcardno}
                                                                        />
                                                                  </Grid>

                                                                  <Grid item xs={2}>
                                                                        <FloatingLabelInput
                                                                            type={"number"}
                                                                            placeholder="روز"
                                                                            handleInputt={(e) => {
                                                                                  this.setState(
                                                                                      {
                                                                                            organ_user_searche_therapy: {...organ_user_searche_therapy,organ_user_therapy_day:e},
                                                                                      })
                                                                            }
                                                                            }
                                                                            value={organ_user_searche_therapy.organ_user_therapy_day}
                                                                        />
                                                                  </Grid>

                                                                  <Grid item xs={2}>
                                                                        <FloatingLabelInput
                                                                            type={"number"}
                                                                            placeholder=" ماه"
                                                                            handleInputt={(e) => {
                                                                                  this.setState(
                                                                                      {
                                                                                            organ_user_searche_therapy: {...organ_user_searche_therapy,organ_user_therapy_month:e},
                                                                                      })
                                                                            }
                                                                            }
                                                                            value={organ_user_searche_therapy.organ_user_therapy_month}
                                                                        />
                                                                  </Grid>
                                                                  <Grid item xs={2}>
                                                                        <FloatingLabelInput
                                                                            type={"number"}
                                                                            placeholder="سال "
                                                                            handleInputt={(e) => {
                                                                                  this.setState(
                                                                                      {
                                                                                            organ_user_searche_therapy: {...organ_user_searche_therapy,organ_user_therapy_year:e},
                                                                                      })
                                                                            }
                                                                            }
                                                                            value={organ_user_searche_therapy.organ_user_therapy_year}
                                                                        />
                                                                  </Grid>

                                                                  <Grid item xs={3}>
                                                                        <FloatingLabelInput
                                                                            placeholder="شماره بیمه"
                                                                            handleInputt={(e) => {
                                                                                  this.setState(
                                                                                      {
                                                                                            organ_user_searche_therapy: {...organ_user_searche_therapy,organ_user_therapy_bimeno:e.target.value},
                                                                                      })
                                                                            }
                                                                            }
                                                                            value={organ_user_searche_therapy.organ_user_therapy_bimeno}
                                                                        />
                                                                  </Grid>

                                                                  <Grid item xs={3}>
                                                                        <div>
                                                                              <label className="on">نوع</label>
                                                                              <Select
                                                                                  isSearchable={true}
                                                                                  className="adapter-txtsize"
                                                                                  placeholder={"نوع"}
                                                                                  value={optionKind.find((x) => parseInt(x.value) ===  parseInt(organ_user_searche_therapy.organ_user_therapy_kind_id))}
                                                                                  onChange={(e) => {  this.setState(
                                                                                      {
                                                                                            organ_user_searche_therapy: {...organ_user_searche_therapy,organ_user_therapy_kind_id:e.value},
                                                                                      })
                                                                                  } }

                                                                                  options={optionKind}
                                                                              />
                                                                        </div>                                                            </Grid>

                                                                  <Grid item xs={6}>
                                                                        <div>
                                                                              <label className="on">نسبت</label>
                                                                              <Select
                                                                                  isSearchable={true}
                                                                                  className="adapter-txtsize"
                                                                                  placeholder={"نسبت"}
                                                                                  value={optionKindship.find((x) => parseInt(x.value) ===  parseInt(organ_user_searche_therapy.organ_user_therapy_kinship_id))}
                                                                                  onChange={(e) => {  this.setState(
                                                                                      {
                                                                                            organ_user_searche_therapy: {...organ_user_searche_therapy,organ_user_therapy_kinship_id:e.value},
                                                                                      })
                                                                                  } }

                                                                                  options={optionKindship}
                                                                              />
                                                                        </div>                                                            </Grid>

                                                                  <Grid item xs={6}>
                                                                        <div>
                                                                              <label className="on">بیمه گر اصلی</label>
                                                                              <Select
                                                                                  isSearchable={true}
                                                                                  className="adapter-txtsize"
                                                                                  placeholder={"بیمه گر اصلی"}
                                                                                  value={optionBaseinsurer.find((x) => parseInt(x.value) ===  parseInt(organ_user_searche_therapy.organ_user_therapy_bank_id))}
                                                                                  onChange={(e) => {  this.setState(
                                                                                      {
                                                                                            organ_user_searche_therapy: {...organ_user_searche_therapy,organ_user_therapy_basebime_id:e.value},
                                                                                      })
                                                                                  } }

                                                                                  options={optionBaseinsurer}
                                                                              />
                                                                        </div>                                                            </Grid>

                                                                  <Grid item xs={3}>
                                                                        <div>
                                                                              <label className="on">بانک</label>
                                                                              <Select
                                                                                  isSearchable={true}
                                                                                  className="adapter-txtsize"
                                                                                  placeholder={"بانک"}
                                                                                  value={optionBank.find((x) => parseInt(x.value) ===  parseInt(organ_user_searche_therapy.organ_user_therapy_bank_id))}
                                                                                  onChange={(e) => {  this.setState(
                                                                                      {
                                                                                            organ_user_searche_therapy: {...organ_user_searche_therapy,organ_user_therapy_bank_id:e.value},
                                                                                      })
                                                                                  } }

                                                                                  options={optionBank}
                                                                              />
                                                                        </div>                                                            </Grid>

                                                                  <Grid item xs={3}>
                                                                        <FloatingLabelInput
                                                                            placeholder="شماره حساب"
                                                                            handleInputt={(e) => {
                                                                                  this.setState(
                                                                                      {
                                                                                            organ_user_searche_therapy: {...organ_user_searche_therapy,organ_user_therapy_accno:e.target.value},
                                                                                      })
                                                                            }
                                                                            }
                                                                            value={organ_user_searche_therapy.organ_user_therapy_accno}
                                                                        />
                                                                  </Grid>
                                                                  <Grid item xs={6}>
                                                                        <FloatingLabelInput
                                                                            placeholder="شماره کارت"
                                                                            handleInputt={(e) => {
                                                                                  this.setState(
                                                                                      {
                                                                                            organ_user_searche_therapy: {...organ_user_searche_therapy,organ_user_therapy_cardno:e.target.value},
                                                                                      })
                                                                            }
                                                                            }
                                                                            value={organ_user_searche_therapy.organ_user_therapy_cardno}
                                                                        />
                                                                  </Grid>
                                                                  <Grid item xs={6}>
                                                                        <FloatingLabelInput
                                                                            placeholder="شماره شبا"
                                                                            handleInputt={(e) => {
                                                                                  this.setState(
                                                                                      {
                                                                                            organ_user_searche_therapy: {...organ_user_searche_therapy,organ_user_therapy_shebano:e.target.value},
                                                                                      })
                                                                            }
                                                                            }
                                                                            value={organ_user_searche_therapy.organ_user_therapy_shebano}
                                                                        />
                                                                  </Grid>

                                                                  <Grid item xs={6}>
                                                                        <FloatingLabelInput
                                                                            placeholder="کد ملی بیمه شده اصلی"
                                                                            handleInputt={(e) => {
                                                                                  this.setState(
                                                                                      {
                                                                                            organ_user_searche_therapy: {...organ_user_searche_therapy,organ_user_therapy_main_national_code:e.target.value},
                                                                                      })
                                                                            }
                                                                            }
                                                                            value={organ_user_searche_therapy.organ_user_therapy_main_national_code}
                                                                        />
                                                                  </Grid>


                                                                  <Grid item xs={3}>
                                                                        <Button variant="outlined" color="primary" onClick={this.getOrganTherapyList}>
                                                                              {"جستجو "}
                                                                        </Button>
                                                                  </Grid>
                                                                  <Grid item xs={3}>
                                                                        <Button variant="outlined" color="primary" onClick={(e) => {
                                                                              this.setState(
                                                                                  {
                                                                                        organ_user_searche_therapy: {
                                                                                              organ_user_therapy_national_code:'',
                                                                                              organ_user_therapy_name:'',
                                                                                              organ_user_therapy_family:'',
                                                                                              user_family:'',
                                                                                              user_mobile:'',
                                                                                              user_name:'',
                                                                                              organ_user_therapy_kinship_id:'',
                                                                                              organ_user_therapy_personal_code:'',
                                                                                              organ_user_therapy_bank_id:'',
                                                                                              organ_user_therapy_kind_id:'',
                                                                                              organ_user_therapy_bimeno:'',
                                                                                              organ_user_therapy_idcardno:'',
                                                                                              organ_user_therapy_cardno:'',
                                                                                              organ_user_therapy_accno:'',
                                                                                              organ_user_therapy_shebano:'',
                                                                                              organ_user_therapy_basebime_id:'',
                                                                                              organ_user_therapy_main_national_code:'',

                                                                                        },
                                                                                  })
                                                                        }}>
                                                                              {"پاک کردن فیلتر ها "}
                                                                        </Button>
                                                                  </Grid>
                                                                  <Grid item xs={12}>
                                                                        <Divider />
                                                                  </Grid>
                                                                  <Grid item xs={12}>
                                                                        <Button
                                                                            variant="outlined"
                                                                            color="primary"
                                                                            onClick={ (event) => {
                                                                                  this.setState({ showPaperChart: false })
                                                                            }}
                                                                        >
                                                                              {"مخفی کردن"}
                                                                        </Button>
                                                                  </Grid>
                                                            </Grid>
                                                      </Collapse>

                                                </Paper>
                                          </Container>
                                    </Grid>
                                    {newKindOrganrequest ? (
                                            <Grid item xs={12}>
                                          <Container component="main" maxWidth="lg">
                                                <Paper elevation={4} className={classes.root}>
                                                      <Grid container spacing={3}>
                                                            <Grid item xs={6}>
                                                                  <Typography align="center" variant="h7">
                                                                        {"آی دی: " + organ_user_therapy.organ_user_therapy_id}
                                                                  </Typography>
                                                            </Grid>
                                                            <Grid item xs={6}>
                                                                  <Typography align="center" variant="h7">
                                                                        {" نام نفر اصلی: " + organ_user_therapy.user_name+" "+organ_user_therapy.user_family +" همراه: "+organ_user_therapy.user_mobile+" id: "+organ_user_therapy.user_id}
                                                                  </Typography>
                                                            </Grid>
                                                            <Grid item xs={2}>
                                                                  <div>
                                                                        <label className="on">جنسیت</label>
                                                                        <Select
                                                                            isSearchable={true}
                                                                            className="adapter-txtsize"
                                                                            placeholder={"شهر"}
                                                                            value={optionGender.find((x) => x.value ===  organ_user_therapy.organ_user_therapy_gender_id)}
                                                                            onChange={(e) => {  this.setState(
                                                                                      {
                                                                                            organ_user_therapy: {...organ_user_therapy,organ_user_therapy_gender_id:e.value},
                                                                                      })
                                                                            } }

                                                                            options={optionGender}
                                                                        />
                                                                  </div>                                                            </Grid>


                                                            <Grid item xs={5}>
                                                                  <FloatingLabelInput
                                                                      placeholder="نام"
                                                                      handleInputt={(e) => {
                                                                            this.setState(
                                                                                {
                                                                                      organ_user_therapy: {...organ_user_therapy,organ_user_therapy_name:e.target.value},
                                                                                })
                                                                      }
                                                                      }
                                                                      value={organ_user_therapy.organ_user_therapy_name}
                                                                  />
                                                            </Grid>
                                                            <Grid item xs={5}>
                                                                  <FloatingLabelInput
                                                                      placeholder="  نام خانوادگی"
                                                                      handleInputt={(e) => {
                                                                            this.setState(
                                                                                {
                                                                                      organ_user_therapy: {...organ_user_therapy,organ_user_therapy_family:e.target.value},
                                                                                })
                                                                      }
                                                                      }
                                                                      value={organ_user_therapy.organ_user_therapy_family}
                                                                  />
                                                            </Grid>
                                                            <Grid item xs={3}>
                                                                  <FloatingLabelInput
                                                                      placeholder="نام پدر"
                                                                      handleInputt={(e) => {
                                                                            this.setState(
                                                                                {
                                                                                      organ_user_therapy: {...organ_user_therapy,organ_user_therapy_fathername:e.target.value},
                                                                                })
                                                                      }
                                                                      }
                                                                      value={organ_user_therapy.organ_user_therapy_fathername}
                                                                  />
                                                            </Grid>
                                                            <Grid item xs={3}>
                                                                  <FloatingLabelInput
                                                                      placeholder=" کد پرسنلی سرپرست"
                                                                      handleInputt={(e) => {
                                                                            this.setState(
                                                                                {
                                                                                      organ_user_therapy: {...organ_user_therapy,organ_user_therapy_personal_code:e.target.value},
                                                                                })
                                                                      }
                                                                      }
                                                                      value={organ_user_therapy.organ_user_therapy_personal_code}
                                                                  />
                                                            </Grid>
                                                            <Grid item xs={3}>
                                                                  <FloatingLabelInput
                                                                      placeholder=" کد ملی"
                                                                      handleInputt={(e) => {
                                                                            this.setState(
                                                                                {
                                                                                      organ_user_therapy: {...organ_user_therapy,organ_user_therapy_national_code:e.target.value},
                                                                                })
                                                                      }
                                                                      }
                                                                      value={organ_user_therapy.organ_user_therapy_national_code}
                                                                  />
                                                            </Grid>

                                                            <Grid item xs={3}>
                                                                  <FloatingLabelInput
                                                                      placeholder="شماره شناسنامه"
                                                                      handleInputt={(e) => {
                                                                            this.setState(
                                                                                {
                                                                                      organ_user_therapy: {...organ_user_therapy,organ_user_therapy_idcardno:e.target.value},
                                                                                })
                                                                      }
                                                                      }
                                                                      value={organ_user_therapy.organ_user_therapy_idcardno}
                                                                  />
                                                            </Grid>

                                                            <Grid item xs={2}>
                                                                  <FloatingLabelInput
                                                                      type={"number"}
                                                                      placeholder="روز"
                                                                      handleInputt={(e) => {
                                                                            this.setState(
                                                                                {
                                                                                      organ_user_therapy: {...organ_user_therapy,organ_user_therapy_day:e},
                                                                                })
                                                                      }
                                                                      }
                                                                      value={organ_user_therapy.organ_user_therapy_day}
                                                                  />
                                                            </Grid>

                                                            <Grid item xs={2}>
                                                                  <FloatingLabelInput
                                                                      type={"number"}
                                                                      placeholder=" ماه"
                                                                      handleInputt={(e) => {
                                                                            this.setState(
                                                                                {
                                                                                      organ_user_therapy: {...organ_user_therapy,organ_user_therapy_month:e},
                                                                                })
                                                                      }
                                                                      }
                                                                      value={organ_user_therapy.organ_user_therapy_month}
                                                                  />
                                                            </Grid>
                                                            <Grid item xs={2}>
                                                                  <FloatingLabelInput
                                                                      type={"number"}
                                                                      placeholder="سال "
                                                                      handleInputt={(e) => {
                                                                            this.setState(
                                                                                {
                                                                                      organ_user_therapy: {...organ_user_therapy,organ_user_therapy_year:e},
                                                                                })
                                                                      }
                                                                      }
                                                                      value={organ_user_therapy.organ_user_therapy_year}
                                                                  />
                                                            </Grid>

                                                            <Grid item xs={3}>
                                                                  <FloatingLabelInput
                                                                      placeholder="شماره بیمه"
                                                                      handleInputt={(e) => {
                                                                            this.setState(
                                                                                {
                                                                                      organ_user_therapy: {...organ_user_therapy,organ_user_therapy_bimeno:e.target.value},
                                                                                })
                                                                      }
                                                                      }
                                                                      value={organ_user_therapy.organ_user_therapy_bimeno}
                                                                  />
                                                            </Grid>

                                                            <Grid item xs={3}>
                                                                  <div>
                                                                        <label className="on">نوع</label>
                                                                        <Select
                                                                            isSearchable={true}
                                                                            className="adapter-txtsize"
                                                                            placeholder={"نوع"}
                                                                            value={optionKind.find((x) => x.value ===  organ_user_therapy.organ_user_therapy_kind_id)}
                                                                            onChange={(e) => {  this.setState(
                                                                                {
                                                                                      organ_user_therapy: {...organ_user_therapy,organ_user_therapy_kind_id:e.value},
                                                                                })
                                                                            } }

                                                                            options={optionKind}
                                                                        />
                                                                  </div>                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <div>
                                                                        <label className="on">نسبت</label>
                                                                        <Select
                                                                            isSearchable={true}
                                                                            className="adapter-txtsize"
                                                                            placeholder={"نسبت"}
                                                                            value={optionKindship.find((x) => x.value ===  organ_user_therapy.organ_user_therapy_kinship_id)}
                                                                            onChange={(e) => {  this.setState(
                                                                                {
                                                                                      organ_user_therapy: {...organ_user_therapy,organ_user_therapy_kinship_id:e.value},
                                                                                })
                                                                            } }

                                                                            options={optionKindship}
                                                                        />
                                                                  </div>                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <div>
                                                                        <label className="on">بیمه گر اصلی</label>
                                                                        <Select
                                                                            isSearchable={true}
                                                                            className="adapter-txtsize"
                                                                            placeholder={"بیمه گر اصلی"}
                                                                            value={optionBaseinsurer.find((x) => x.value ===  organ_user_therapy.organ_user_therapy_basebime_id)}
                                                                            onChange={(e) => {  this.setState(
                                                                                {
                                                                                      organ_user_therapy: {...organ_user_therapy,organ_user_therapy_basebime_id:e.value},
                                                                                })
                                                                            } }

                                                                            options={optionBaseinsurer}
                                                                        />
                                                                  </div>                                                            </Grid>

                                                            <Grid item xs={3}>
                                                                  <div>
                                                                        <label className="on">بانک</label>
                                                                        <Select
                                                                            isSearchable={true}
                                                                            className="adapter-txtsize"
                                                                            placeholder={"بانک"}
                                                                            value={optionBank.find((x) => x.value ===  organ_user_therapy.organ_user_therapy_bank_id)}
                                                                            onChange={(e) => {  this.setState(
                                                                                {
                                                                                      organ_user_therapy: {...organ_user_therapy,organ_user_therapy_bank_id:e.value},
                                                                                })
                                                                            } }

                                                                            options={optionBank}
                                                                        />
                                                                  </div>                                                            </Grid>

                                                            <Grid item xs={3}>
                                                                  <FloatingLabelInput
                                                                      placeholder="شماره حساب"
                                                                      handleInputt={(e) => {
                                                                            this.setState(
                                                                                {
                                                                                      organ_user_therapy: {...organ_user_therapy,organ_user_therapy_accno:e.target.value},
                                                                                })
                                                                      }
                                                                      }
                                                                      value={organ_user_therapy.organ_user_therapy_accno}
                                                                  />
                                                            </Grid>
                                                            <Grid item xs={6}>
                                                                  <FloatingLabelInput
                                                                      placeholder="شماره کارت"
                                                                      handleInputt={(e) => {
                                                                            this.setState(
                                                                                {
                                                                                      organ_user_therapy: {...organ_user_therapy,organ_user_therapy_cardno:e.target.value},
                                                                                })
                                                                      }
                                                                      }
                                                                      value={organ_user_therapy.organ_user_therapy_cardno}
                                                                  />
                                                            </Grid>
                                                            <Grid item xs={6}>
                                                                  <FloatingLabelInput
                                                                      placeholder="شماره شبا"
                                                                      handleInputt={(e) => {
                                                                            this.setState(
                                                                                {
                                                                                      organ_user_therapy: {...organ_user_therapy,organ_user_therapy_shebano:e.target.value},
                                                                                })
                                                                      }
                                                                      }
                                                                      value={organ_user_therapy.organ_user_therapy_shebano}
                                                                  />
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <FloatingLabelInput
                                                                      placeholder="کد ملی بیمه شده اصلی"
                                                                      handleInputt={(e) => {
                                                                            this.setState(
                                                                                {
                                                                                      organ_user_therapy: {...organ_user_therapy,organ_user_therapy_main_national_code:e.target.value},
                                                                                })
                                                                      }
                                                                      }
                                                                      value={organ_user_therapy.organ_user_therapy_main_national_code}
                                                                  />
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  {newKindOrganrequest ? (
                                                                      <>
                                                                      <Button
                                                                          variant="outlined"
                                                                          color="primary"
                                                                          onClick={(e) => {
                                                                                this.newKindOrganrequestFunc()
                                                                          }}
                                                                      >
                                                                            {"ثبت روش توزیع جدید "}
                                                                      </Button>
                                                                      {"          "}
                                                                        <Button
                                                                        variant="outlined"
                                                                        color="primary"
                                                                        onClick={(e) => {
                                                                        this.ChangeUserTherapyUserList()
                                                                  }}
                                                                        >
                                                                  {"ثبت تغییرات"}
                                                                        </Button>
                                                                  {"          "}
                                                                        <Button
                                                                        variant="outlined"
                                                                        color="primary"
                                                                        onClick={(e) => {
                                                                        this.deletKindOrganrequest()
                                                                  }}
                                                                        >
                                                                  {"حذف روش"}
                                                                        </Button>
                                                                      </>
                                                                  ) : (
                                                                      <div style={{ width: "100%", textAlign: "right" }}>
                                                                            <Button
                                                                                variant="outlined"
                                                                                color="primary"
                                                                                onClick={this.newKindOrganrequestFunc}
                                                                            >
                                                                                  {"روش توزیع جدید"}
                                                                            </Button>
                                                                            {"          "}
                                                                            <Button
                                                                                variant="outlined"
                                                                                color="primary"
                                                                                onClick={(e) => {
                                                                                      this.ChangeUserTherapyList()
                                                                                }}
                                                                            >
                                                                                  {"ثبت تغییرات"}
                                                                            </Button>
                                                                            {"          "}
                                                                            <Button
                                                                                variant="outlined"
                                                                                color="primary"
                                                                                onClick={(e) => {
                                                                                      this.deletKindOrganrequest()
                                                                                }}
                                                                            >
                                                                                  {"حذف روش"}
                                                                            </Button>
                                                                      </div>
                                                                  )}
                                                            </Grid>
                                                      </Grid>
                                                </Paper>
                                          </Container>
                                    </Grid>
                                        ):""}

                                    <Grid item xs={12}>
                                          <Container maxWidth="lg">
                                                <Paper className={classes.root}>
                                                      <TableContainer dir="rtl">
                                                            <Table aria-label="sticky table">
                                                                  <TableHead>
                                                                        <TableRow>
                                                                              <TableCell>
                                                                                    <ExcelFile
                                                                                          element={
                                                                                                <Button variant="outlined" color="primary">
                                                                                                      {" "}
                                                                                                      {"اکسل "}
                                                                                                </Button>
                                                                                          }
                                                                                    >
                                                                                          <ExcelSheet data={agentInfofilter} name="نمایندگان">
                                                                                                <ExcelColumn
                                                                                                      label="organ_user_therapy_name"
                                                                                                      value="organ_user_therapy_name"
                                                                                                />
                                                                                                <ExcelColumn
                                                                                                      label="organ_user_therapy_family"
                                                                                                      value="organ_user_therapy_family"
                                                                                                />
                                                                                                <ExcelColumn label="organ_user_therapy_name" value="organ_user_therapy_name" />
                                                                                                <ExcelColumn label="organ_user_therapy_family" value="organ_user_therapy_family" />
                                                                                                <ExcelColumn label="organ_user_therapy_personal_code" value="organ_user_therapy_personal_code" />
                                                                                                <ExcelColumn label="organ_user_therapy_national_code" value="organ_user_therapy_national_code" />
                                                                                                <ExcelColumn label="organ_user_therapy_gender_id" value="organ_user_therapy_gender_id" />
                                                                                                <ExcelColumn label="organ_user_therapy_year" value="organ_user_therapy_year" />
                                                                                                <ExcelColumn label="organ_user_therapy_month" value="organ_user_therapy_month" />
                                                                                                <ExcelColumn label="organ_user_therapy_day" value="organ_user_therapy_day" />
                                                                                                <ExcelColumn label="organ_user_therapy_fathername" value="organ_user_therapy_fathername" />
                                                                                                <ExcelColumn label="organ_user_therapy_kind_id" value="organ_user_therapy_kind_id" />
                                                                                                <ExcelColumn label="organ_user_therapy_kinship_id" value="organ_user_therapy_kinship_id" />
                                                                                                <ExcelColumn label="organ_user_therapy_basebime_id" value="organ_user_therapy_basebime_id" />
                                                                                                <ExcelColumn label="organ_user_therapy_bank_id" value="organ_user_therapy_bank_id" />
                                                                                                <ExcelColumn label="organ_user_therapy_cardno" value="organ_user_therapy_cardno" />
                                                                                                <ExcelColumn label="organ_user_therapy_accno" value="organ_user_therapy_accno" />
                                                                                                <ExcelColumn label="organ_user_therapy_shebano" value="organ_user_therapy_shebano" />
                                                                                                <ExcelColumn label="organ_user_therapy_bimeno" value="organ_user_therapy_bimeno" />
                                                                                                <ExcelColumn label="organ_user_therapy_idcardno" value="organ_user_therapy_idcardno" />
                                                                                                <ExcelColumn label="user_mobile" value="user_mobile" />
                                                                                                <ExcelColumn label="organ_user_therapy_main_national_code" value="organ_user_therapy_main_national_code" />

                                                                                          </ExcelSheet>
                                                                                    </ExcelFile>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                  key={"organ_user_therapy_gender_id"}
                                                                                  align={"center"}
                                                                                  style={{ minWidth: 20 }}
                                                                                  sortDirection={
                                                                                        orderBy === "organ_user_therapy_gender_id" ? order : false
                                                                                  }
                                                                              >
                                                                                    {"جنسیت "}
                                                                                    <TableSortLabel
                                                                                        active={orderBy === "organ_user_therapy_gender_id"}
                                                                                        direction={
                                                                                              orderBy === "organ_user_therapy_gender_id"
                                                                                                  ? order
                                                                                                  : "asc"
                                                                                        }
                                                                                        onClick={(e) => {
                                                                                              this.createSortHandler("organ_user_therapy_gender_id")
                                                                                        }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"organ_user_therapy_name"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"نام"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "organ_user_therapy_name"}
                                                                                          direction={orderBy === "organ_user_therapy_name" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("organ_user_therapy_name")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"organ_user_therapy_family"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"نام خانوادگی"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "organ_user_therapy_family"}
                                                                                          direction={orderBy === "organ_user_therapy_family" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("organ_user_therapy_family")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>
                                                                              <TableCell key={"organ_user_therapy_personal_code"} align={"center"} style={{ minWidth: 60 }}>
                                                                                    {"  کد پرستلی سرپرست"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "organ_user_therapy_personal_code"}
                                                                                          direction={orderBy === "organ_user_therapy_personal_code" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("organ_user_therapy_personal_code")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"organ_user_therapy_national_code"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {" کد ملی"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "organ_user_therapy_national_code"}
                                                                                          direction={orderBy === "organ_user_therapy_national_code" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("organ_user_therapy_national_code")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"organ_user_therapy_idcardno"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {" شماره شناسنامه"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "organ_user_therapy_idcardno"}
                                                                                          direction={orderBy === "organ_user_therapy_idcardno" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("organ_user_therapy_idcardno")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"organ_user_therapy_fathername"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {" نام پدر"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "organ_user_therapy_fathername"}
                                                                                          direction={
                                                                                                orderBy === "organ_user_therapy_fathername" ? order : "asc"
                                                                                          }
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("organ_user_therapy_fathername")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell key={"organ_user_therapy_kind_id"} align={"center"} style={{ minWidth: 60 }}>
                                                                                    {" نوع   "}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "organ_user_therapy_kind_id"}
                                                                                          direction={orderBy === "organ_user_therapy_kind_id" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("organ_user_therapy_kind_id")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"organ_user_therapy_kinship_id"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"  نسبت "}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "organ_user_therapy_kinship_id"}
                                                                                          direction={orderBy === "organ_user_therapy_kinship_id" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("organ_user_therapy_kinship_id")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                  key={"organ_user_therapy_year"}
                                                                                  align={"center"}
                                                                                  style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"سال"}
                                                                                    <TableSortLabel
                                                                                        active={orderBy === "organ_user_therapy_year"}
                                                                                        direction={orderBy === "organ_user_therapy_year" ? order : "asc"}
                                                                                        onClick={(e) => {
                                                                                              this.createSortHandler("organ_user_therapy_year")
                                                                                        }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>
                                                                              <TableCell
                                                                                  key={"organ_user_therapy_month"}
                                                                                  align={"center"}
                                                                                  style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"ماه"}
                                                                                    <TableSortLabel
                                                                                        active={orderBy === "organ_user_therapy_month"}
                                                                                        direction={orderBy === "organ_user_therapy_month" ? order : "asc"}
                                                                                        onClick={(e) => {
                                                                                              this.createSortHandler("organ_user_therapy_month")
                                                                                        }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                  key={"organ_user_therapy_day"}
                                                                                  align={"center"}
                                                                                  style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"روز"}
                                                                                    <TableSortLabel
                                                                                        active={orderBy === "organ_user_therapy_day"}
                                                                                        direction={orderBy === "organ_user_therapy_day" ? order : "asc"}
                                                                                        onClick={(e) => {
                                                                                              this.createSortHandler("organ_user_therapy_day")
                                                                                        }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                                  <TableCell
                                                                                  key={"organ_user_therapy_basebime_id"}
                                                                                  align={"center"}
                                                                                  style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"بیمه گر اصلی"}
                                                                                    <TableSortLabel
                                                                                        active={orderBy === "organ_user_therapy_basebime_id"}
                                                                                        direction={orderBy === "organ_user_therapy_basebime_id" ? order : "asc"}
                                                                                        onClick={(e) => {
                                                                                              this.createSortHandler("organ_user_therapy_basebime_id")
                                                                                        }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                  key={"organ_user_therapy_bank_id"}
                                                                                  align={"center"}
                                                                                  style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"بانک"}
                                                                                    <TableSortLabel
                                                                                        active={orderBy === "organ_user_therapy_bank_id"}
                                                                                        direction={orderBy === "organ_user_therapy_bank_id" ? order : "asc"}
                                                                                        onClick={(e) => {
                                                                                              this.createSortHandler("organ_user_therapy_bank_id")
                                                                                        }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                  key={"organ_user_therapy_cardno"}
                                                                                  align={"center"}
                                                                              >
                                                                                    {" شماره کارت"}
                                                                                    <TableSortLabel
                                                                                        active={orderBy === "organ_user_therapy_cardno"}
                                                                                        direction={orderBy === "organ_user_therapy_cardno" ? order : "asc"}
                                                                                        onClick={(e) => {
                                                                                              this.createSortHandler("organ_user_therapy_cardno")
                                                                                        }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                  key={"organ_user_therapy_accno"}
                                                                                  align={"center"}
                                                                                  style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"شماره حساب"}
                                                                                    <TableSortLabel
                                                                                        active={orderBy === "organ_user_therapy_accno"}
                                                                                        direction={orderBy === "organ_user_therapy_accno" ? order : "asc"}
                                                                                        onClick={(e) => {
                                                                                              this.createSortHandler("organ_user_therapy_accno")
                                                                                        }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                  key={"organ_user_therapy_shebano"}
                                                                                  align={"center"}
                                                                              >
                                                                                    {"شماره شبا"}
                                                                                    <TableSortLabel
                                                                                        active={orderBy === "organ_user_therapy_shebano"}
                                                                                        direction={orderBy === "organ_user_therapy_shebano" ? order : "asc"}
                                                                                        onClick={(e) => {
                                                                                              this.createSortHandler("organ_user_therapy_shebano")
                                                                                        }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>


                                                                              <TableCell
                                                                                  key={"organ_user_therapy_bimeno"}
                                                                                  align={"center"}
                                                                              >
                                                                                    {" شماره بیمه"}
                                                                                    <TableSortLabel
                                                                                        active={orderBy === "organ_user_therapy_bimeno"}
                                                                                        direction={orderBy === "organ_user_therapy_bimeno" ? order : "asc"}
                                                                                        onClick={(e) => {
                                                                                              this.createSortHandler("organ_user_therapy_bimeno")
                                                                                        }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                  key={"user_name"}
                                                                                  align={"center"}
                                                                              >
                                                                                    {"نام نفر اصلی"}
                                                                                    <TableSortLabel
                                                                                        active={orderBy === "user_name"}
                                                                                        direction={orderBy === "user_name" ? order : "asc"}
                                                                                        onClick={(e) => {
                                                                                              this.createSortHandler("user_name")
                                                                                        }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>


                                                                        </TableRow>
                                                                  </TableHead>

                                                                  <TableBody>
                                                                        {agentInfofilter.slice(0, rowsPerPage)
                                                                              .map((row) => {
                                                                                    return (
                                                                                          <TableRow
                                                                                                hover
                                                                                                role="checkbox"
                                                                                                tabIndex={-1}
                                                                                                key={row["organ_user_therapy_id"]}
                                                                                                value={row}
                                                                                                onClick={() => {
                                                                                                      this.handleSelectRows(row)
                                                                                                }}
                                                                                          >
                                                                                                <TableCell
                                                                                                      key={"organ_user_therapy_id"}
                                                                                                      align={"center"}
                                                                                                >
                                                                                                      {row["organ_user_therapy_id"]}
                                                                                                </TableCell>

                                                                                                <TableCell
                                                                                                    key={"organ_user_therapy_gender_id"}
                                                                                                    align={"center"}
                                                                                                >
                                                                                                      {(optionGender.find((x) => parseInt(x.value) ===  parseInt(row["organ_user_therapy_gender_id"])))?
                                                                                                          optionGender.find((x) => parseInt(x.value) === parseInt( row["organ_user_therapy_gender_id"])).label
                                                                                                          :""}
                                                                                                </TableCell>
                                                                                                <TableCell key={"organ_user_therapy_name"} align={"center"}>
                                                                                                      {row["organ_user_therapy_name"]}
                                                                                                </TableCell>

                                                                                                <TableCell key={"organ_user_therapy_family"} align={"center"}>
                                                                                                      {row["organ_user_therapy_family"]}
                                                                                                </TableCell>

                                                                                                <TableCell key={"organ_user_therapy_personal_code"} align={"center"}>
                                                                                                      {row["organ_user_therapy_personal_code"]}
                                                                                                </TableCell>

                                                                                                <TableCell
                                                                                                      key={"organ_user_therapy_national_code"}
                                                                                                      align={"center"}
                                                                                                >
                                                                                                      {row["organ_user_therapy_national_code"]}
                                                                                                </TableCell>

                                                                                                <TableCell
                                                                                                      key={"organ_user_therapy_idcardno"}
                                                                                                      align={"center"}
                                                                                                >
                                                                                                      {row["organ_user_therapy_idcardno"]}
                                                                                                </TableCell>

                                                                                                <TableCell
                                                                                                      key={"organ_user_therapy_fathername"}
                                                                                                      align={"center"}
                                                                                                >
                                                                                                      {row["organ_user_therapy_fathername"]}
                                                                                                </TableCell>


                                                                                                <TableCell key={"organ_user_therapy_kind_id"} align={"center"}>
                                                                                                      {(optionKind.find((x) => parseInt(x.value) ===  parseInt(row["organ_user_therapy_kind_id"])))?
                                                                                                          optionKind.find((x) => parseInt(x.value) === parseInt( row["organ_user_therapy_kind_id"])).label
                                                                                                          :""}
                                                                                                </TableCell>

                                                                                                <TableCell key={"organ_user_therapy_kinship_id"} align={"center"}>
                                                                                                      {(optionKindship.find((x) => parseInt(x.value) ===  parseInt(row["organ_user_therapy_kinship_id"])))?
                                                                                                          optionKindship.find((x) => parseInt(x.value) === parseInt( row["organ_user_therapy_kinship_id"])).label
                                                                                                          :""}
                                                                                                </TableCell>

                                                                                                <TableCell key={"organ_user_therapy_year"} align={"center"}>
                                                                                                      {row["organ_user_therapy_year"]}
                                                                                                </TableCell>

                                                                                                <TableCell key={"organ_user_therapy_month"} align={"center"}>
                                                                                                      {row["organ_user_therapy_month"]}
                                                                                                </TableCell>

                                                                                                <TableCell key={"organ_user_therapy_day"} align={"center"}>
                                                                                                      {row["organ_user_therapy_day"]}
                                                                                                </TableCell>

                                                                                                <TableCell key={"organ_user_therapy_basebime_id"} align={"center"}>
                                                                                                      {(optionBaseinsurer.find((x) => parseInt(x.value) ===  parseInt(row["organ_user_therapy_basebime_id"])))?
                                                                                                          optionBaseinsurer.find((x) => parseInt(x.value) === parseInt( row["organ_user_therapy_basebime_id"])).label
                                                                                                          :""}
                                                                                                </TableCell>

                                                                                                <TableCell key={"organ_user_therapy_bank_id"} align={"center"}>
                                                                                                      {(optionBank.find((x) => parseInt(x.value) ===  parseInt(row["organ_user_therapy_bank_id"])))?
                                                                                                          optionBank.find((x) => parseInt(x.value) === parseInt( row["organ_user_therapy_bank_id"])).label
                                                                                                          :""}
                                                                                                </TableCell>

                                                                                               <TableCell key={"organ_user_therapy_cardno"} align={"center"}>
                                                                                                      {row["organ_user_therapy_cardno"]}
                                                                                                </TableCell>

                                                                                                <TableCell key={"organ_user_therapy_accno"} align={"center"}>
                                                                                                      {row["organ_user_therapy_accno"]}
                                                                                                </TableCell>


                                                                                                <TableCell key={"organ_user_therapy_shebano"} align={"center"}>
                                                                                                      {row["organ_user_therapy_shebano"]}
                                                                                                </TableCell>


                                                                                                <TableCell key={"organ_user_therapy_bimeno"} align={"center"}>
                                                                                                      {row["organ_user_therapy_bimeno"]}
                                                                                                </TableCell>
                                                                                                <TableCell key={"user_name"} align={"center"}>
                                                                                                      {row["user_name"]}
                                                                                                </TableCell>


                                                                                          </TableRow>
                                                                                    )
                                                                              })}
                                                                  </TableBody>
                                                            </Table>
                                                      </TableContainer>
                                                      <TablePagination
                                                          rowsPerPageOptions={[10, 25, 100, 1000, 5000, 10000, 100000]}
                                                            component="div"
                                                            count={arrCount}
                                                            rowsPerPage={rowsPerPage}
                                                            page={page}
                                                            onChangePage={this.handleChangePage}
                                                            onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                                      />
                                                </Paper>
                                          </Container>
                                    </Grid>
                              </Grid>

                              {okstatus ? (
                                    <Alert severity="success">
                                          <AlertTitle>پیام</AlertTitle>
                                          {errstr}
                                    </Alert>
                              ) : null}
                        </div>
                  )
            }
      }
}

export default withStyles(styles)(ChangeUserTherapyList)
